@if (iconConfiguration$ | async; as iconConfiguration) {

<h-icon-button
    class="back-button"
    [class.apply-default-height]="!shouldInheritHeight"
    id="back-button-id"
    name="back-button"
    label="Back button"
    i18n-label
    [appearance]="iconConfiguration.isDesktop ? 'SVG_WITH_TEXT_LEFT' : 'SVG_ONLY'"
    [changeOpacityOnHover]="appearance === 'primary'"
    [backgroundColor]="appearance"
    [buttonSize]="iconConfiguration.buttonSize"
    [border]="false"
    [iconSize]="iconConfiguration.iconSize + 'px'"
    lineHeight="0"
    (pressed)="handleButtonClicked()">
    <h-svg-icon name="back-arrow" class="back-icon" [class.left]="iconConfiguration.isDesktop"></h-svg-icon>
    @if (iconConfiguration.isDesktop) {
    <span class="back-text paragraph-medium" i18n="@@node--hermes-product-display-default.back" text>Back</span>
    }
</h-icon-button>

}
